import {
  FETCH_ALL_STUDENTS_BEGIN,
  FETCH_ALL_STUDENTS_SUCCESS,
  FETCH_ALL_STUDENTS_ERROR
} from '../actions/getStudentsAction';

import {
  DELETE_STUDENT_BEGIN,
  DELETE_STUDENT_SUCCESS,
  DELETE_STUDENT_ERROR
} from '../actions/deleteStudent';

import {
  UPDATE_STUDENT_BEGIN,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_ERROR
} from '../actions/updateStudent';
import { ADD_FILTER_STUDENTS, REMOVE_FILTER_STUDENTS } from 'modules/Admin/redux/actions/filterStudents';

const initialState = {
  filter: [],
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_STUDENTS_BEGIN:
    case DELETE_STUDENT_BEGIN:
    case UPDATE_STUDENT_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case FETCH_ALL_STUDENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data.map((user, i) => {
          user.id = i;
          return user;
        })
      };


    case DELETE_STUDENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: state.data.filter((user) => user._id !== action.payload.data)
      };

    case UPDATE_STUDENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: state.data.map((user) => {
          if (user._id === action.payload.data._id) {
            return action.payload.data;
          }
          return user;
        })
      };

    case ADD_FILTER_STUDENTS:
      return {
        ...state,
        filter: [...state.filter, {
          key: action.key,
          text: action.text,
          isExact: action.exact
        }]
      };

    case REMOVE_FILTER_STUDENTS:
      return {
        ...state,
        filter: state.filter.filter( item => item.key !== action.key)
      };

    case FETCH_ALL_STUDENTS_ERROR:
    case DELETE_STUDENT_ERROR:
    case UPDATE_STUDENT_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
        data: []
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/Admin/redux/reducers/studentReducer.js